import React, { lazy, Suspense, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Analytics from "analytics";
import googleTagManager from "@analytics/google-tag-manager";
import googleAnalytics from "@analytics/google-analytics";
import ReactPixel from "react-facebook-pixel";
import { Box, ThemeProvider } from "@mui/material";
import theme from "./theme";
import LazySpinner from "./components/LazySpinner";
import MetaTags from "./components/MetaTags";
import ContactUsBtn from "./components/ContactUsBtn";
const Landing = lazy(() => import("./components/Landing"));
const ArticlesLayout = lazy(() => import("./components/Articles/ArticlesLayout"));
const ArticlesList = lazy(() => import("./components/Articles/ArticlesList"));
const ArticleView = lazy(() => import("./components/Articles/ArticleView"));
const VideoList = lazy(() => import("./components/Articles/VideoList"));
const SubmitProfile = lazy(() => import("./components/SubmitProfile"));
const PrivateLayout = lazy(() => import("./components/PrivateLayout"));
const CardPreviewLayout = lazy(() => import("./components/CardPreviewLayout"));
const SignInForm = lazy(() => import("./components/Auth/SignInForm"));
const SignTemplate = lazy(() => import("./components/Auth/SignTemplate"));
const SignUpForm = lazy(() => import("./components/Auth/SignUpForm"));
const MainTemplate = lazy(() => import("./components/Main/MainTemplate"));
const HomeSection = lazy(() => import("./components/Main/HomeSection"));
const ProfileSection = lazy(() => import("./components/Main/ProfileSection"));
const PriceListSection = lazy(() => import("./components/Main/PriceListSection"));

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV === "production" && navigator.userAgent !== "ReactSnap") {
      const analytics = Analytics({
        app: "DentalBot",
        plugins: [googleTagManager({ containerId: "GTM-KBXRGTC" }), googleAnalytics({ trackingId: "UA-171390954-5" })],
      });
      analytics.page();
      ReactPixel.init("646027579412816");
      ReactPixel.pageView();
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Suspense
        fallback={
          <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
            <LazySpinner />
          </Box>
        }
      >
        <MetaTags />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/submit-profile/:token" element={<SubmitProfile />} />
          <Route path="/preview/:previewLink" element={<CardPreviewLayout />} />
          <Route element={<ArticlesLayout />}>
            <Route path="/articles/:articleUrl" element={<ArticleView />} />
            <Route path="/articles" element={<ArticlesList />} />
            <Route path="/videos" element={<VideoList />} />
          </Route>
          <Route element={<SignTemplate />}>
            <Route path="/sign-in" element={<SignInForm />} />
            <Route path="/sign-up" element={<SignUpForm />} />
          </Route>
          <Route element={<PrivateLayout />}>
            <Route path="/company" element={<MainTemplate />}>
              <Route index element={<HomeSection />} />
              <Route path="settings" element={<ProfileSection />} />
              <Route path="price-list" element={<PriceListSection />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ContactUsBtn />
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
